// LoadingContext.js
import React, { createContext, useContext, useState } from 'react';

const LoadingContext = createContext();

export function LoadingProvider({ children }) {
    const [isLoading, setIsLoading] = useState(false);
    const [ loading, setLoading ] = useState(false);
    return (
        <LoadingContext.Provider value={{ isLoading, setIsLoading,setLoading ,loading}}>
            {children}
        </LoadingContext.Provider>
    );
}

export function useLoading() {
    return useContext(LoadingContext);
}
